/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

/**
 * Genres displays a comma-separated list of genres as a styled caption.
 * @param categoryLabel - The string of genres to display.
 * @param className - Optional CSS class for custom styling.
 * @param limit - Optional limit on number of genres to display (default is 2).
 */
const Genres: FunctionComponent<{ categoryLabel?: string; className?: string; limit?: number }> = ({
    categoryLabel,
    className: aClassName = '',
    limit = 2,
}) => {
    if (!categoryLabel) return null;
    let modifiedCategoryLabel = categoryLabel;
    if (limit > 0) {
        const genresArray = modifiedCategoryLabel.split(',').map((genre) => genre.trim());
        if (genresArray.length > limit) {
            const limitedGenres = genresArray.slice(0, limit);
            modifiedCategoryLabel = limitedGenres.join(', ');
        }
    }
    const defaultClassName = 'primary-text-style muted-color text-light';
    return (
        <React.Fragment>
            {modifiedCategoryLabel ? (
                <span className={`uikit ${aClassName || defaultClassName}`}>
                    {modifiedCategoryLabel}
                </span>
            ) : null}
        </React.Fragment>
    );
};

export default Genres;
